export default __webpack_public_path__ + "e339863594dda160068493d9b8b5240c.png";